import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LicenceCreateDto, LicenceDto } from '../dtos/dtos';

@Injectable({
  providedIn: 'root',
})
export class LicenceService {
  constructor(private http: HttpClient) {}

  getAllByAccountPerma(permaId: string): Observable<LicenceDto[]> {
    return this.http.get<LicenceDto[]>(
      `${environment.apiUrl}/accounts/${permaId}/licences`,
    );
  }

  continueSubscription(
    permaId: string,
    accountPerma: string,
  ): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.apiUrl}/accounts/${accountPerma}/licences/${permaId}/continue`,
      null,
    );
  }

  stopSubscription(permaId: string, accountPerma: string): Observable<boolean> {
    return this.http.post<boolean>(
      `${environment.apiUrl}/accounts/${accountPerma}/licences/${permaId}/stop`,
      null,
    );
  }

  getUnpaidLicenceCount(
    accountPerma: string,
  ): Observable<{ [year: number]: LicenceDto }> {
    return this.http.get<{ [year: number]: LicenceDto }>(
      `${environment.apiUrl}/accounts/${accountPerma}/licences/unpaid`,
    );
  }

  //

  private adminUrl = `${environment.apiUrl}/admin/licences`;

  getAll(): Observable<LicenceDto[]> {
    return this.http.get<LicenceDto[]>(this.adminUrl);
  }

  get(perma: string): Observable<LicenceDto> {
    return this.http.get<LicenceDto>(`${this.adminUrl}/${perma}`);
  }

  create(licenceDto: LicenceCreateDto): Observable<void> {
    return this.http.post<void>(this.adminUrl, licenceDto);
  }

  copyForYear(perma: string, year: number): Observable<void> {
    return this.http.post<void>(
      `${this.adminUrl}/${perma}/copy-for-year/${year}`,
      null,
    );
  }

  update(perma: string, licence: LicenceCreateDto): Observable<void> {
    return this.http.put<void>(`${this.adminUrl}/${perma}`, licence);
  }

  delete(perma: string): Observable<void> {
    return this.http.delete<void>(`${this.adminUrl}/${perma}`);
  }
}
